window.onload = function () {
  setTimeout(function () {
    $(".product-form__buttons").css("opacity", "1");
  }, 300);

  if ($(window).width() <= 767) {
    setTimeout(function () {
      $(".product-gallerymedia").css("height", "auto");
      $(".product-gallerymedia").css("overflow", "inherit");
    }, 300); // Delay in milliseconds
  }

  $("#one_review").animate({ opacity: 1 }, 400);
  $("#one_review a").on("click", () => {
    window.sendTrackingEvent("PDP - Reviews Highlight Click");
  });
  /*
setTimeout(function () {
   $('product-recommendations fieldset input[type="radio"]:nth-child(2)').first().prop('checked', true).trigger('change');
   $('product-recommendations fieldset .color-swatch:nth-child(3)').trigger('click');
   alert(1);

}, 3000); // Delay in milliseconds

*/
};

$("body").on("click", ".header_h5", function (e) {
  if (!$(this).hasClass("active")) window.sendTrackingEvent("PDP - Accordion Open", { event_detail: $(this).text().trim().replace(/\s+/g, " ") });
  $(".box-a1").find(".level-box").stop().slideUp();
  $(this).closest(".box-a1").find(".level-box").stop().slideToggle();

  $(".header_h5").not(this).removeClass("active");
  $(this).toggleClass("active");
});

/*
 window.onload = function () {
    setTimeout(function () {
      // ✅ Check and select the second radio input
      $('product-recommendations fieldset input[type="radio"]:nth-child(2)').prop('checked', true).trigger('change');

      // ✅ Click the third color swatch
      $('product-recommendations fieldset .color-swatch:nth-child(3)').trigger('click');

     $("#one_review").css('opacity', '1');

    }, 700); // Delay in milliseconds
};
*/
